export interface columninfo {
    field: string;
    header: string;
  }

  export class cColumninfo implements columninfo {
    field: string;
    header: string;
  }